import React__default from 'react';
import { Wrapper } from './styles.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Use the LinkWithIcon component to style an anchor tag with anchor tags with platform hyperlink color cues and hover text decoration,
 * while also respecting accessibility.
 *
 * When choosing a link or a button, links are used for destinations, whenever the action may refresh the browers,
 * or when moving from one page to another.
 *
 * The LinkWithIcon component can be used as a semantic `button`, by using `<LinkWithIcon as='button' onClick={your onClick here}>.
 *
 * If you use the `as` prop, be sure to pass the inclusive and semantically correct element, such as an `a`, `button`, or
 * `summary` tag.
 */

const LinkWithIcon = ({
  icon,
  variant = 'iconAfter',
  iconSize = 16,
  children,
  ...delegated
}) => {
  let Component;
  switch (variant) {
    case 'iconBefore':
      Component = LinkWithIconBefore;
      break;
    case 'iconAfter':
      Component = LinkWithIconAfter;
      break;
    default:
      throw new Error(`unrecognized ${variant}, please use 'iconBefore' or 'iconAfter' variant with LinkWithIcon.`);
  }
  return /*#__PURE__*/React__default.createElement(Wrapper, _extends({
    style: {
      '--size': iconSize + 'px'
    }
  }, delegated), /*#__PURE__*/React__default.createElement(Component, {
    icon: icon
  }, children));
};
LinkWithIcon.displayName = "LinkWithIcon";
const LinkWithIconBefore = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.icon, props.children);
};
const LinkWithIconAfter = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.children, props.icon);
};
var LinkWithIcon$1 = LinkWithIcon;

export { LinkWithIcon$1 as default };
